import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../../../context/AuthContext';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useCompanies = (showMessage) => {
  const [companies, setCompanies] = useState([]);
  // Starts true (not false) so the page-level skeleton is guaranteed to be
  // visible on first paint instead of racing the mount effect that flips it.
  const [loading, setLoading] = useState(true);

  const fetchCompanies = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiFetch(`${BASE_URL}/api/configurations/companies`, {
        method: 'GET',
      });
      const data = await response.json();
      setCompanies(data?.data || []);
    } catch (error) {
      console.error('Failed to fetch companies:', error);
      showMessage('error', 'Failed to load companies');
    } finally {
      setLoading(false);
    }
  }, [showMessage]);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const addCompany = async (companyName) => {
    if (!companyName.trim()) {
      showMessage('error', 'Please enter a company name');
      return false;
    }

    try {
      const response = await apiFetch(`${BASE_URL}/api/configurations/companies/new`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clientName: companyName.trim() }),
      });

      if (response.status === 409) {
        showMessage('error', 'Company already exists');
        return false;
      } else if (!response.ok) {
        showMessage('error', 'Failed to create company');
        return false;
      } else {
        showMessage('success', 'Company created successfully!');
        await fetchCompanies();
        return true;
      }
    } catch (error) {
      console.error('Failed to create company:', error);
      showMessage('error', 'Failed to create company');
      return false;
    }
  };

  return { companies, loading, fetchCompanies, addCompany };
};